var map = {
	"./DAA.jpg": 74233,
	"./DAP.jpg": 88148,
	"./DIRP.jpg": 67156,
	"./DMC.jpg": 56717,
	"./DRD.jpg": 8186,
	"./IQAC.jpg": 13537,
	"./NSS.jpg": 78130,
	"./PLACEMENTS.jpg": 92287,
	"./RESULTS.jpg": 37118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44867;